module.exports = __webpack_public_path__ + "img/reaction-link-logo-gray.dfd5d06f.png";